import { Button, Col, Input, Row, Form, message } from "antd"
import { AuthContext } from "../../contexts/auth/AuthContext"   // s88
import { canManageLogins } from "../../utils/loginRights"   // s88
import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { CREATE_USER } from "../../rest-api/mutations/user"
// import {
//   createUser,
//   createUserVariables,
// } from "../../rest-api/mutations/types/createUser"
import useQueryParams from "../../hooks/useQueryParams"
import { useMutation } from "@tanstack/react-query"

export default function AddAdminForm() {
  const { t } = useTranslation()
  const query = useQueryParams()
  const { authState } = useContext(AuthContext)
  const loginOk = canManageLogins((authState as any)?.user)   // s88
  const {
    mutate: createUser,
    isLoading: loading,
    error,
  } = useMutation(CREATE_USER, {
    onSuccess: () => {
      message.success(t("success"))
      query.goBack()
    },
    onError: (err) => message.error(String(err)),
  })

  function handleFinish(values: any) {
    createUser({
      // variables: { ...values, userName: "Administrator" },
      ...values,
    })
  }

  if (!loginOk) return null   // s88: huquqsiz foydalanuvchi bu tugmani/formani umuman ko'rmaydi
  return (
    <Form onFinish={handleFinish} layout="vertical" requiredMark>
      <Row gutter={15}>
        <Col sm={24}>
          <Form.Item
            name="email"
            label={t("email")}
            rules={[{ required: true }]}
          >
            <Input
              type="email"
              addonAfter="@"
              size="large"
              placeholder={t("email")}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="password"
            label={t("password")}
            rules={[{ required: true }]}
          >
            <Input.Password size="large" placeholder={t("password")} />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="confirmPassword"
            label={t("confirmPassword")}
            rules={[{ required: true }]}
          >
            <Input.Password size="large" placeholder={t("confirmPassword")} />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Button
            loading={loading}
            danger={!!error}
            block
            type="primary"
            htmlType="submit"
          >
            {t("save")}
          </Button>
        </Col>
      </Row>
    </Form>
  )
}
